<template>
  <div>
    <b-modal
      :id="`modal-image-viewer${id}`"
      modal-class="modal-image-viewer"
      ok-title="OK"
      cancel-variant="outline-secondary"
      scrollable
      title="圖片"
      title-class="font-weight-bolder"
      body-class="common_modal "
      hide-header
      hide-footer
      centered
      size="xl"
    >
      <font-awesome-icon
        @click="hide"
        class="close-button"
        style="font-size: 25px"
        icon="fa-solid fa-circle-xmark"
      />

      <div v-if="imageList && imageList.length > 0" class="image-viewer-wrapper">
        <b-carousel
          :value="selected_file"
          id="carousel-2"
          class="mt-2 image-viewer-carousel"
          :interval="0"
          indicators
          no-animation
          controls
          background="#ababab"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide
            v-for="(file, index) of imageList"
            :key="`view${index}`"
          >
            <template #img>
             <div class="text-center">{{ file.name}}</div>
              <embed
                v-if="file.type == 'application/pdf'"
                id="pdfcontainer"
                class="pdf"
                :src="file.src"
                type="application/pdf"
              />
              <img
                v-else
                class="d-block image"
                :src="file.src"
                alt="image slot"
              />
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import { BModal, BCarousel, BCarouselSlide, VBModal } from "bootstrap-vue";

export default {
  components: {
    BModal,
    BCarousel,
    BCarouselSlide,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {};
  },
  methods: {
    hide() {
      this.$bvModal.hide(`modal-image-viewer${this.id}`);
    },

    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    imageList: {
      type: Array,
      require: true,
    },
    selected_file: {
      type: Number,
      require: true,
    },
  },
  computed: {
    // imageuUrl() {
    //   console.log('this.imageList',this.imageList)
    //   if(this.id.indexOf(`-preview`) > -1){
    //     return this.imageList;
    //   }else{
    //     return process.env.VUE_APP_IMAGE_URL + this.imageList;
    //   }
    // },
  },
};
</script>
  
<style lang="scss">

// 預覽媒體的可視高度：扣除 modal 上下留白與指示點
$viewer-media-height: calc(100vh - 12rem);

.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
}

// modal-body（common_modal）是 flex 容器，不撐滿的話 PDF 會縮回 embed 預設的 300px 寬
.image-viewer-wrapper {
  width: 100%;
}

$viewer-control-width: 48px;

.image-viewer-carousel {
  background: transparent !important;
  // 左右留出箭頭位置，箭頭不再壓在 PDF 上、也不會推出框外造成橫向捲軸
  padding: 0 $viewer-control-width;

  .carousel-control-prev,
  .carousel-control-next {
    width: $viewer-control-width;
  }
  .carousel-control-prev {
    left: 0;
  }
  .carousel-control-next {
    right: 0;
  }
  .carousel-item {
    background: transparent !important;
    max-width: 1200px;
    width: 100%;
    height: auto;
    margin: 0 auto 50px;

    .image {
      display: block;
      margin: 0 auto;
      max-width: 100%;
      max-height: $viewer-media-height;
      object-fit: contain;
    }

    // embed 的高度不能用百分比（父層為 auto 會塌成一條），要給實際高度
    .pdf {
      display: block;
      margin: 0 auto;
      width: 100%;
      height: $viewer-media-height;
      min-height: 320px;
      border: 0;
    }
  }
  .carousel-indicators {
    bottom: -30px;
  }
}
</style>
  
  